import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import Constants from '../Constants';

@Component({
  selector: 'app-external-document-modal',
  templateUrl: './external-document-modal.component.html',
  styleUrls: ['./external-document-modal.component.scss'],
})
export class ExternalDocumentModalComponent {
  public title = '';
  public text = '';
  public pictureUrls: string[] = [];
  public keywords: string[] = [];

  constructor(public activeModal: NgbActiveModal) {}

  setDocumentInfo(documentInfo) {
    this.title = documentInfo['title'];
    this.text = documentInfo['text'];
    this.pictureUrls = documentInfo['pictures'] || [];
    if (this.pictureUrls.length === 0) {
      this.pictureUrls = [Constants.documentPoint.defaultPicture];
    }

    this.keywords = documentInfo['keywords'];
  }

  getKeywordString() {
    return this.keywords.map(keywords => keywords.toUpperCase()).join(', ');
  }

  close() {
    this.activeModal.close();
  }
}
